import React, { useContext, useEffect, useState } from "react";
import "../../styles/find-car-form.css";
import { Form, FormGroup, Input } from "reactstrap";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { globalContext } from "../Layout/Layout";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { toggleLogin } from "../../Features/authSlice";
import axios from "axios";
import { addfindCarDetails } from "../../Features/bookingSlice";
import axiosInstance from "../../axiosInstance";
import { constants } from "../../Utils/constants";

const FindCarForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { toggleLogin } = useContext(globalContext);
  // const [, setSelectedDateForTripStart] = useState(new Date());
  // const [, setSelectedDateForTripEnd] = useState(new Date());

  //const cities = [{ id: "1", location: "Pune" }];

  const branche = [
    { id: "1", location: "Hinjewadi" },
    { id: "2", location: "Baner" },
    { id: "3", location: "Wakad" },
    { id: "4", location: "Aundh" },
  ];
  const [branches, setBranches] = useState([]);
  const [cities, setCity] = useState([]);

  let minDateForTripStart = new Date();
  const maxDateForTripStart = new Date();

  const [formData, setFormData] = useState({
    city: "",
    branchId: "",
    selectedDateForTripStart: new Date(),
    selectedDateForTripEnd: new Date(),
  });

 

  useEffect(() => {
    const allBranchList = async () => {
      const resp = await axiosInstance.get(constants.serverUrl+"/branches/all");
      if (resp.data?.status == false) {
        toast.error(resp.data?.message, {
          theme: "colored",
        });
      } else {
        let temp = resp.data.map((item) => item.city);
        setCity([...new Set(temp.flat())]);

        setBranches(resp.data);
      }
    };
    allBranchList();
  }, []);

  const filterBranchCity = () => {
    let temp = branches.map((item) => item.city);
    setCity([...new Set(temp.flat())]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDateChangeForTripStart = (date) => {
    setFormData({ ...formData, selectedDateForTripStart: date });
  };

  const handleDateChangeForTripEnd = (date) => {
    setFormData({ ...formData, selectedDateForTripEnd: date });
  };

  let handleColor = (time) => {
    return time.getHours() > 5 && time.getHours() < 23 ? "text" : "text-danger";
  };

  const handleSubmit = () => {
    if (formData.city.trim() === "")
      toast.error("City Is Not Filled !!!", { theme: "colored" });
    else if (formData.branchId.trim() === "")
      toast.error("Location Is Not Filled !!!", { theme: "colored" });
    else if (formData.selectedDateForTripStart === "")
      toast.error("Trip Start Date Not Filled !!!", { theme: "colored" });
    else if (formData.selectedDateForTripEnd <= new Date())
      toast.error("Trip End Date Not Filled !!!", { theme: "colored" });
    else {
      if (sessionStorage?.getItem("token") !== null) {
        dispatch(addfindCarDetails(formData));
        navigate("/cars");
      } else {
        dispatch(toggleLogin());
      }
    }
  };

  useEffect(() => {
    handleDateChangeForTripEnd();
  }, [formData.selectedDateForTripStart]);

  return (
    <Form method="post" className="form">
      <div className=" d-flex align-items-center justify-content-between flex-wrap">
        <FormGroup className="form__group">
          <Input
            type="select"
            name="city"
            id="city"
            onChange={handleInputChange}
          >
            <option>Select Your City</option>
            {cities.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </Input>
        </FormGroup>
        <FormGroup className="form__group">
          <Input
            type="select"
            name="branchId"
            id="branchLocation"
            disabled={formData.city ? false : true}
            onChange={handleInputChange}
          >
            <option>Select Nearby Branch</option>
            {branches
              .filter((branch) => branch.city == formData.city)
              .map((b) => (
                <option value={b.id}>{b.locality}</option>
              ))}
          </Input>
        </FormGroup>

        <FormGroup className="form__group">
          <DatePicker
            name="fromDateTime"
            showTimeSelect
            selected={formData.selectedDateForTripStart}
            onChange={handleDateChangeForTripStart}
            minDate={minDateForTripStart.setDate(minDateForTripStart.getDate())}
            maxDate={maxDateForTripStart.setDate(
              maxDateForTripStart.getDate() + 2
            )}
            placeholderText="When to start your trip ?"
            timeClassName={handleColor}
            timeIntervals={30}
            timeCaption="Time"
            minTime={new Date().setHours(6, 0)}
            maxTime={new Date().setHours(23, 0)}
            dateFormat="yyyy-MM-dd HH:mm:ss"
          />
        </FormGroup>

        <FormGroup className="form__group">
          <DatePicker
            name="toDateTime"
            showTimeSelect
            selected={formData.selectedDateForTripEnd}
            onChange={handleDateChangeForTripEnd}
            minDate={formData.selectedDateForTripStart}
            maxDate={minDateForTripStart.setDate(
              formData.selectedDateForTripStart.getDate() + 15
            )}
            placeholderText="How long it's going to be ?"
            timeClassName={handleColor}
            timeIntervals={30}
            timeCaption="Time"
            minTime={new Date().setHours(6, 0)}
            maxTime={new Date().setHours(23, 0)}
            dateFormat="yyyy-MM-dd HH:mm:ss"
          />
        </FormGroup>
        <FormGroup className="form__group">
          <button
            type="button"
            className="btn find__car-btn"
            onClick={handleSubmit}
          >
            Find Car
          </button>
        </FormGroup>
      </div>
    </Form>
  );
};

export default FindCarForm;
